import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: SetupHint,
});

/** Shown when the kiosk URL is missing its screen token. */
function SetupHint() {
  return (
    <main className="flex h-screen flex-col items-center justify-center gap-4 bg-[#0e0d0b] text-center text-white">
      <h1 className="font-display text-4xl font-semibold">Just One Drink · Venue Screen</h1>
      <p className="max-w-md text-lg text-white/60">
        เปิดหน้าจอนี้ด้วยลิงก์จาก Owner Admin:{" "}
        <code className="text-amber-300">/s/&lt;screen-token&gt;</code>
      </p>
    </main>
  );
}
